export const odluka_usvajanje_fin_izvj = {
  templateId: 205,
  category: 4,
  templateTitle: 'Odluka o utvrđivanju financijskih izvještaja',
  templateDescription: `<p>Zakonima je propisana obveza sastavljanja GFI-a radi javne objave te predaja GFI-a za statističke i druge potrebe. Uprava je odgovorna za izradu GFI-a (i dostavu u rokovima) te ista dostavlja skupštini društva/nadzornom odboru na odobrenje.</p>`,
  description: `
  <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
  <p>Obveza sastavljanja GFI-a radi javne objave i a predaja GFI-a za statističke i druge potrebe definirana je zakonima u podnožju ovog teksta.</p>
  <p>Prema Zakonu o trgovačkim društvima, financijska izvješća sastavlja uprava, odnosno izvršni direktori u skladu s propisima o računovodstvu. Ona je dužna izrađena financijska izvješća (i izvješće o stanju društva, ako ga je društvo dužno izraditi) bez odgađanja dostaviti nadzornom odboru (ako postoji takvo tijelo) i skupštini društva. Ako je potrebno obaviti reviziju financijskih izvješća društva, uprava je dužna, uz izrađena spomenuta izvješća zajedno s izvješćem o stanju društva dostaviti i revizorsko izvješće nadzornom odboru (ako postoji) i skupštini društva. </p>
  <p>Odluku o utvrđivanju godišnjih financijskih izvještaja potpisuje predsjednik skupštine ili nadzornog odbora, ako poduzetnik ima ta tijela. Ako poduzetnik nema tih tijela, tada je postupak sljedeći: ako postoji jedan vlasnik, on sam potpisuje odluke, a ako postoje dva vlasnika, tada bi društvo trebalo imati odluku o ovlasti za potpis takve dokumentacije i postupati u skladu s tom odlukom. Odluke ne trebaju biti ovjerene žigom poduzetnika.</p>
  <p>Uprava mora svakome članu društva bez odgađanja, po njihovoj izradi dostaviti godišnja financijska izvješća, izvješće o stanju društva, ako ga je društvo dužno izraditi, i godišnja financijska izvješća koncerna, kao i izvješće o stanju koncerna kako bi oni mogli pisanim putem u zakonom propisanom roku, koji se ne može produljiti društvenim ugovorom, utvrditi godišnja financijska izvješća društva na skupštini ili posebnom odlukom. </p>
  <p>Ako je godišnja financijska izvješća pregledao revizor, njegovo se izvješće mora dostaviti bez odgađanja kada ga društvo primi. Za vrijeme od 14 dana prije ispitivanja godišnjih financijskih izvješća u skupštini društva ili prije isteka roka za donošenje odluke o utvđivanju financijskih izvještaja, svaki član društva ima pravo uvida u poslovne knjige i dokumentaciju društva. Ako društvo po zakonu mora imati nadzorni odbor ili je to predviđeno društvenim ugovorom, tim se ugovorom može odrediti da: članovi društva nemaju spomenuto pravo uvida, da im se za to daje kraći rok od onog propisanog zakonom ili ih se može podvrći drugim ograničenjima. U tom slučaju se svim članovima društva mora bez odgađanja dostaviti izvješće uprave o stanju društva, ako ga je društvo dužno izraditi, prijedlog odluke o upotrebi dobiti, izvješće revizora, ako ga društvo ima, i izvješće revizora u pogledu koncerna.    </p>

  <p>Društvo nema obvezu dostavljanja GFI-a nadzornom odboru (ako postoji takvo tijelo) i skupštini društva ako su za sve vrijeme za koje su članovi društva imali po zakonu pravo uvida u njih, bile objavljene na internetskoj stranici društva.</p>
  <p>Prema Zakonu o računovodstvu, poduzetnik, odnosno pravna i fizička osoba koja ne dostavi FINA-i godišnje financijske izvještaje, godišnje izvješće, revizorsko izvješće (ako je dužan revidirati godišnje financijske izvještaje) i druge dokumente radi javne objave, kaznit će se za prekršaj novčanom kaznom u iznosu od 10.000 do 100.000 kuna. Za odgovornu osobu poduzetnika također je propisana novčana kazna u iznosu od 5.000 do 20.000 kuna. </p>
  <p>Nadležni trgovački sud po službenoj dužnosti može pokrenuti postupak brisanja za ona društva koja tri godine zaredom ne predaju godišnje financijske izvještaje u svrhu javne objave.</p>
  <h5>PRAVNA OSNOVA</h5>
  <p>Zakon o računovodstvu, Zakon o trgovačkim društvima i Zakon o sudskom registru</p>
  `,
  sides: [
      {
          prefix: 'Na temelju odredbi Zakona o trgovačkim društvima i Zakona o računovodstvu,',
          signature: 'Predsjednik skupštine',
          inputs: [{
              type: "input",
              required: true,
              placeholder: "Poslovni subjekt",
            },
            {
              type: "input",
              required: true,
              placeholder: "Ulica i kućni broj",
            },
            {
              type: "input",
              required: true,
              placeholder: "Mjesto",
            },
            {
              type: "input",
              required: true,
              placeholder: "OIB",
            },
            {
              type: "input",
              placeholder: "Zastupa",
              inSignature: true,
            },
            {
              type: "input",
              placeholder: "Funkcija",
              inSignature: true,
            }],
            suffix: " (u daljnjem tekstu: Društvo),",
      }
  ],

  headline: '​donosi sljedeću',
  title: 'ODLUKU O UTVRĐIVANJU GODIŠNJEG FINANCIJSKOG IZVJEŠTAJA',
  noArticleNumbers: true,

  articles: [

    {
      title: '',
      mandatory: false,
      exampleContent: true,
      statements: [
          {
              type: 'text',
              editable: true,
              mandatory: true,
              content: 'Sukladno propisima, Uprava Društva je za 20__. godinu sastavila i predočila skupštini društva na prihvaćanje sljedeće temeljne financijske i porezne izvještaje: \r\n1. Bilanca, \r\n2. Račun dobiti i gubitka,  \r\n3. Bilješke uz temeljne financijske izvještaje, \r\n4. Prijava poreza na dobit za 20__. godinu, \r\n5. Obrazac GFI-POD za potrebe javne objave.',
              value: '',
          }],
  },
  {
    title: '',
    mandatory: false,
    exampleContent: true,
    statements: [
        {
            type: 'text',
            editable: true,
            mandatory: true,
            content: 'Bilanca na dan 31.12.____. godine iskazuje zbroj aktive u svoti _________ kn.',
            value: '',
        }],
},
  {
    title: '',
    mandatory: true,
    statements: [
        {
            type: 'choice',
            mandatory: true,
            editable: true,
            choices: [
                'Utvrđuje se račun dobiti i gubitka za godinu koja je završila 31.12. 20__. godine, u kojem iskazana svota dobiti nakon oporezivanja iznosi ________ kn.',
                'Utvrđuje se račun dobiti i gubitka za godinu koja je završila 31.12. 20__. godine, u kojem iskazana svota gubitka nakon oporezivanja iznosi ________ kn.',              ],
            placeholder: "Odaberite ovdje te potom izmijenite po želji...",  
        }
    ]
  },
  {
      title: '',
      mandatory: false,
      exampleContent: true,
      statements: [
          {
              type: 'text',
              mandatory: true,
              editable: true,
              content: 'Financijski izvještaji odobreni su od Uprave dana ___.___ 20__. godine za podnošenje skupštine društva i potpisani su od strane _______________. ',
              value: '',
          }],
  },
  {
    title: '',
    mandatory: false,
    statements: [
        {
            type: 'text',
            mandatory: true,
            editable: true,
            content: 'Odluka se primjenjuje s danom donošenja.',
            value: '',
        }],
},
  {
    mandatory: true,
    static: true,
    type: 2, // date and place
    statements: [
        {
            type: 'input',
            mandatory: true,
            parts: [
                {
                    type: 'text',
                    content: 'U'
                },
                {
                    type: 'input',
                    value: '',
                    placeholder: "Upišite mjesto.",
                    required: true
                },
                {
                    type: 'text',
                    content: ', dana'
                },
                {
                    type: 'date',
                    value: new Date(),
                    required: true
                },
                {
                    type: 'text',
                    content: 'godine.',
                }
            ]
        },
    ]
},
{
    mandatory: true,
    static: true,
    type: 3,  // signatures
    statements: [],
},
{
    static: true,
    mandatory: false,
    type: 4, 
    statements: [
        {
            type: 'text',
            mandatory: true,
            editable: true,
            content: 'Dostaviti:\r\n1) Odjel knjigovodstva \r\n2) Arhiva',
            help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
        }
    ]
},
],
};






// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/205_odluka_usvajanje_fin_izvj.ts